import axios from 'axios/index';
import React, {PureComponent} from 'react';

import { Classes, Overlay, Callout, Intent } from "@blueprintjs/core";

import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import toastr from 'toastr';
import { getJwt } from '../../services/authService';
import http from '../../services/httpService';

const facebook_app_id = process.env.REACT_APP_FACEBOOK_APP_ID;

export default class EnableMessengerModal extends PureComponent{
    state = {

    }

    responseFacebookForSourceEnable = async (response) => {
        try {
            this.setState({
                fb_spinner: true
            });
            if (response.status !== 'unknown' || (typeof (response.status) !== 'undefined')) {
                if (response.name !== "" && (typeof (response.name) !== 'undefined')) {
                    let source = "";
                    let sources = this.props.sources;
                    let selectedSource = this.props.selectedSource;
                    //let feeds_shared = this.props.feeds_shared;
                    if (sources) {
                        source = sources.filter(source =>
                            source.id.toString() === selectedSource.toString())[0];
                    }
                    // if (!source && feeds_shared) {
                    //     source = feeds_shared.filter(source =>
                    //         source.project_id.toString() === selectedSource.toString())[0];
                    // }
                    let feed_id = source.id;
                    if (feed_id === "page_source") {
                        feed_id = ""
                    }
                    let login_facebook_response = {};
                    // console.log("responseFacebook response ", response, feed_id);j
                    if (response.email && response.email !== "") {
                        try{
                            login_facebook_response = await http.post('api/login_facebook/' + feed_id, response, {headers: {authorization: getJwt()}});
                            await this.props.enablePlatform({
                                target: {
                                    id: "fb_enable",
                                    title: source.id.toString()
                                }
                            });
                            this.setState({clicked_fb: true});


                            // Update user
                            const data = login_facebook_response.data ? login_facebook_response.data.data : "";
                            const missing_allowed_pages = login_facebook_response.data.missing_allowed_pages.filter(page => page.connected )
                            if (data) {
                                this.setState({
                                    user: Object.assign(
                                        {},
                                        this.state.user,
                                        {
                                            facebook_pages: data.facebook_pages,
                                            facebook_pages_shared: data.facebook_pages_shared,
                                            missing_allowed_pages
                                        }
                                    )
                                });
                                await this.props.updateUser({
                                    facebook_pages: data.facebook_pages,
                                    facebook_pages_shared: data.facebook_pages_shared,
                                    missing_allowed_pages
                                })
                            }
                            /* Updating platforms_enabled */
                            if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled && this.props.platforms_enabled.length > 0) {

                                let result = await http.patch('api/feed/' + this.props.selectedSource, {active: 1}, {headers: {authorization: getJwt()}});
                                let platformsEnabled = await result.data.platforms_enabled

                                this.props.updateSources(result.data);
                                this.props.selectSource({
                                    id: result.data.id,
                                    source_active: true,
                                    selected_source_rss: result.data.rss
                                })
                            }
                            this.props.handleFinish();
                            this.props.handleClose();
                        }catch(e) {
                            toastr.error("Facebook channel enabling was unsuccessful, please try later.")
                        }

                    } else {
                        toastr.error("Email obtain permission has to be checked in order to register!")
                    }
                }
                this.setState({
                    fb_spinner: false
                });
            } else {
                toastr.error("Facebook response undefined! Please try later, or,  try standard register approach instead.")
            }
        } catch (ex) {
            this.setState({
                fb_spinner: false
            });
        }


    };
    render(){
        return(
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER} isOpen={this.props.showModal}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field" style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className="separator" style={{position: 'absolute', top: 50, left: 0, width: '100%'}}></div>
                    <h3 style={{marginTop: -15, marginBottom: 30}}>Enable Messenger</h3>
                    <p className="modal-close-button" onClick={ () =>{this.props.handleClose()} }><i className="fas fa-times"></i></p>
                    <div className="onboarding-panel">

                        <Callout icon='info-sign' intent={Intent.PRIMARY}>
                            Messenger is not enabled.
                        </Callout>
                        <p>Do you want to enable and set it up now?<br/>
                            It only take 5 minutes.</p>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                            <div style={{marginRight: 20}}>
                                <button
                                    disabled={ false }
                                    onClick={ () =>{
                                        this.props.handleClose()
                                    } }
                                    name="cancel_delete_tag"
                                    id="cancel_delete_tag"
                                    type="button"
                                    className='btn-transparent-border btn-sm m-sm-b center'>Cancel</button>
                            </div>
                            <div>
                                {
                                    this.state.fb_spinner ?
                                        <button className="btn-action btn-spinner">
                                            <p style={{margin: 0}}>Enable <i className='fa fa-spin fa-spinner'/></p>
                                        </button>
                                        :
                                        <FacebookLogin
                                            appId={facebook_app_id}
                                            autoLoad={false}
                                            return_scopes={true}
                                            fields="name, email, picture"
                                            scope="email, public_profile, pages_messaging, pages_read_engagement"
                                            callback={this.responseFacebookForSourceEnable}
                                            render={renderProps => (
                                                <button onClick={renderProps.onClick} className="btn-action">
                                                    <p style={{margin: 0}}>Enable</p>
                                                </button>
                                            )}
                                        />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}